import cn from 'classnames';
import { MdCheck } from 'react-icons/md';
import { Spinner } from '@Components/Spinner';

interface SaveIndicatorProps {
  saving: boolean;
  saved: boolean;
}

const SaveIndicator = ({ saving, saved }: SaveIndicatorProps) => {
  if (!saving && !saved) return null;

  return (
    <div className={cn('cps-save-indicator', { saving, saved })}>
      {saving && (
        <>
          <Spinner />
          <span>Saving draft...</span>
        </>
      )}
      {!saving && saved && (
        <>
          <MdCheck />
          <span>Draft saved</span>
        </>
      )}
    </div>
  );
};

export { SaveIndicator };
